module.exports = __webpack_public_path__ + "media/media/about/partner-2-53fe572f76c132ef76fa53cbb20f03b3.png";